import { O } from '../../../features/ui'
import { TableName } from '../../../tables'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { FiscalDocument } from '../state/types'

export const useFiscalDocumentLoaders = () => {
    const systemHooks = useSystemStateHooks()
    
    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const loadFiscalDocument = (
            id: string,
            dbRequest = false
        ) => {
            const { load } = loaders(companyId)
            return load(TableName.FISCAL_DOCUMENTS, id, dbRequest) as Promise<O<FiscalDocument>>
        }

        const loadOperationFiscalDocuments = async (
            operationId: string,
            optimized = true
        ) => {
            const { loadMultiple } = loaders(companyId)
            const options = {
                valueFilters: [{ prop: 'operationId', value: operationId }]
            }
            const response = await loadMultiple(TableName.FISCAL_DOCUMENTS, options, optimized)
            return response.dataTypes as FiscalDocument[]
        }

        return {
            loadFiscalDocument,
            loadOperationFiscalDocuments
        }
    }
}
